<script>
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'
import { PRESETS, FISCAL_PRESETS } from '@/mixins/SharedServiceData'
import DateHelpers from '@/mixins/DateHelpers'

export default {
  components: {
    'mia-feature-select': FeatureSelect
  },

  mixins: [DateHelpers],

  data: () => ({
    regularPresets: [
      {
        id: PRESETS.lastMonth,
        label: 'Letzter Monat'
      },
      {
        id: PRESETS.yesterday,
        label: 'Gestern'
      },
      {
        id: PRESETS.thisWeek,
        label: 'Aktuelle Woche'
      },
      {
        id: PRESETS.thisMonth,
        label: 'Aktueller Monat'
      },
      {
        id: PRESETS.thisYear,
        label: 'Aktuelles Jahr'
      },
      {
        id: PRESETS.all,
        label: 'Gesamtübersicht'
      }
    ],
    fiscalPresets: [
      {
        id: FISCAL_PRESETS.thisYear,
        label: 'Laufendes Geschäftsjahr'
      },
      {
        id: FISCAL_PRESETS.lastYear,
        label: 'Vergangenes Geschäftsjahr'
      }
    ]
  }),

  computed: {
    selectedPreset() {
      return this.$store.state.service.filters.global.preset
    },

    dateFrom() {
      return this.$store.state.service.filters.global.dateFrom
    },

    dateTo() {
      return this.$store.state.service.filters.global.dateTo
    },

    isPresetOrDateInvalid() {
      return this.selectedPreset === '' || this.dateFrom === '' || this.dateTo === ''
    },

    isDateRangeOutOfPreset() {
      if (this.selectedPreset === '') {
        return true
      }

      if (this.selectedPreset === PRESETS.custom) {
        return false
      }

      const { from, to } = this.getPresetDateRange(this.selectedPreset)

      return this.dateFrom !== from || this.dateTo !== to
    }
  },

  watch: {
    selectedPreset(newSelectedPreset) {
      if (newSelectedPreset === PRESETS.custom) {
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    }
  },

  created() {
    if (this.isPresetOrDateInvalid || this.isDateRangeOutOfPreset) {
      this.applyPreset(this.selectedPreset === '' || this.selectedPreset === PRESETS.custom ? PRESETS.thisMonth : this.selectedPreset)
    } else {
      this.$nextTick(() => {
        this.$emit('preset-changed')
      })
    }
  },

  methods: {
    onInput(preset) {
      this.$store.commit('service/setGlobalPreset', preset)
      this.applyPreset(preset)
    },

    getPresetDateRange(preset) {
      switch (preset) {
        case PRESETS.lastMonth:
          return { from: this.startOfLastMonth, to: this.endOfLastMonth }

        case PRESETS.yesterday:
          return { from: this.yesterday, to: this.yesterday }

        case PRESETS.thisWeek:
          return { from: this.startOfThisWeek, to: this.endOfThisWeek }

        case PRESETS.thisYear:
          return { from: this.startOfThisYear, to: this.endOfThisYear }

        case FISCAL_PRESETS.thisYear:
          return { from: this.startOfThisFiscalYear, to: this.endOfThisFiscalYear }

        case FISCAL_PRESETS.lastYear:
          return { from: this.startOfLastFiscalYear, to: this.endOfLastFiscalYear }

        // This Month / Default
        default:
          return { from: this.startOfThisMonth, to: this.endOfThisMonth }
      }
    },

    applyPreset(preset) {
      const { from, to } = this.getPresetDateRange(preset)

      this.$store.commit('service/setGlobalDateFrom', from)
      this.$store.commit('service/setGlobalDateTo', to)

      this.$nextTick(() => {
        this.$emit('preset-changed')
      })
    }
  }
}
</script>

<template>
  <mia-feature-select
    v-bind="$attrs"
    :value="selectedPreset"
    label="Vorlage"
    name-by="label"
    track-by="id"
    v-on="$listeners"
    @input="onInput"
  >
    <template #options>
      <option
        value=""
        disabled
        class="text-gray-500"
      >
        Vorlage wählen
      </option>
      <option
        v-if="selectedPreset === 'custom'"
        value="custom"
        disabled
        class="text-gray-500"
      >
        Selbst gewählter Bereich
      </option>
      <optgroup label="Zeitraum">
        <option
          v-for="preset in regularPresets"
          :key="preset.id"
          class="text-black"
          :value="preset.id"
        >
          {{ preset.label }}
        </option>
      </optgroup>
      <optgroup label="Geschäftsjahr">
        <option
          v-for="preset in fiscalPresets"
          :key="preset.id"
          class="text-black"
          :value="preset.id"
        >
          {{ preset.label }}
        </option>
      </optgroup>
    </template>
  </mia-feature-select>
</template>
